module.exports = __webpack_public_path__ + "static/media/typical-right-pinta-house.26febf09.webp";